import React, { forwardRef, useState } from "react";
import { useStableId } from "@/hooks/useStableId";
import type { TextareaHTMLAttributes } from "react";
import "@/styles/textarea-field.css";

type TextareaFieldProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  rootClassName?: string;
};

const TextareaField = forwardRef<HTMLTextAreaElement, TextareaFieldProps>(function TextareaField(
  {
    id,
    label,
    error,
    className,
    rootClassName,
    icon,
    dir = "rtl",
    rows = 4,
    onFocus,
    onBlur,
    ...textareaProps
  },
  ref
) {
  var generatedId = useStableId("textarea-field");
  var textareaId = id !== undefined && id !== null && id !== "" ? id : generatedId;
  var focusState = useState(false);
  var isFocused = focusState[0];
  var setIsFocused = focusState[1];

  var boxClass = "textarea-field__box";
  if (error) {
    boxClass = boxClass + " is-error";
  } else if (isFocused) {
    boxClass = boxClass + " is-focused";
  }
  if (className) {
    boxClass = boxClass + " " + className;
  }

  return (
    <div className={"textarea-field " + (rootClassName ? rootClassName : "")}>
      {label ? (
        <label htmlFor={textareaId} className="textarea-field__label">
          {label}
        </label>
      ) : null}

      <div className={boxClass}>
        {icon ? <span className="textarea-field__icon">{icon}</span> : null}

        <textarea
          id={textareaId}
          dir={dir}
          rows={rows}
          className="textarea-field__input"
          {...textareaProps}
          onFocus={function (e) {
            setIsFocused(true);
            if (onFocus) {
              onFocus(e);
            }
          }}
          onBlur={function (e) {
            setIsFocused(false);
            if (onBlur) {
              onBlur(e);
            }
          }}
          ref={ref}
        />
      </div>

      {error ? <p className="textarea-field__error">{error}</p> : null}
    </div>
  );
});

export default TextareaField;
